import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { NdrRecordEntity } from './ndr-record.model';

export enum NdrRecordActionTypes {
  LoadNdrRecords = '[NdrRecord] Load NdrRecords',
  AddNdrRecord = '[NdrRecord] Add NdrRecord',
  UpsertNdrRecord = '[NdrRecord] Upsert NdrRecord',
  AddNdrRecords = '[NdrRecord] Add NdrRecords',
  UpsertNdrRecords = '[NdrRecord] Upsert NdrRecords',
  UpdateNdrRecord = '[NdrRecord] Update NdrRecord',
  UpdateNdrRecords = '[NdrRecord] Update NdrRecords',
  DeleteNdrRecord = '[NdrRecord] Delete NdrRecord',
  DeleteNdrRecords = '[NdrRecord] Delete NdrRecords',
  ClearNdrRecords = '[NdrRecord] Clear NdrRecords',
}

export class LoadNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.LoadNdrRecords;

  constructor(public payload: { ndrRecords: NdrRecordEntity[] }) {}
}

export class AddNdrRecord implements Action {
  public readonly type = NdrRecordActionTypes.AddNdrRecord;

  constructor(public payload: { ndrRecord: NdrRecordEntity }) {}
}

export class UpsertNdrRecord implements Action {
  public readonly type = NdrRecordActionTypes.UpsertNdrRecord;

  constructor(public payload: { ndrRecord: NdrRecordEntity }) {}
}

export class AddNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.AddNdrRecords;

  constructor(public payload: { ndrRecords: NdrRecordEntity[] }) {}
}

export class UpsertNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.UpsertNdrRecords;

  constructor(public payload: { ndrRecords: NdrRecordEntity[] }) {}
}

export class UpdateNdrRecord implements Action {
  public readonly type = NdrRecordActionTypes.UpdateNdrRecord;

  constructor(public payload: { ndrRecord: Update<NdrRecordEntity> }) {}
}

export class UpdateNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.UpdateNdrRecords;

  constructor(public payload: { ndrRecords: Update<NdrRecordEntity>[] }) {}
}

export class DeleteNdrRecord implements Action {
  public readonly type = NdrRecordActionTypes.DeleteNdrRecord;

  constructor(public payload: { id: string }) {}
}

export class DeleteNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.DeleteNdrRecords;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearNdrRecords implements Action {
  public readonly type = NdrRecordActionTypes.ClearNdrRecords;
}

export type NdrRecordActions =
  | LoadNdrRecords
  | AddNdrRecord
  | UpsertNdrRecord
  | AddNdrRecords
  | UpsertNdrRecords
  | UpdateNdrRecord
  | UpdateNdrRecords
  | DeleteNdrRecord
  | DeleteNdrRecords
  | ClearNdrRecords;
